import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'mileageRates';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const mileageRatesActions = { ...slice.actions, ...extraActions };
export const mileageRatesReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        mileageRates: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/MileageReimbursement`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetMileageRates`)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.mileageRates = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.mileageRates = action.payload;
            },
            [rejected]: (state, action) => {
                state.mileageRates = { error: action.error };
            }
        };
    }
}
